import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface GetAuthMemberResponse {
  [index: number]: {
    RmiMembKeyId: string,
    RmiMembId: string,
    RmiMembMpiNo: string,
    RmiLastNm: string,
    RmiFirstNm: string,
    RmiSex: string,
    RmiBirth: string,
    RmiStartDate: string,
    RmiEndDate: string,
    RmiHpCode: string,
    RmiOpt: string,
    RmiCompanyId: string,
    RmiProviderKeyId: string,
    RmiSpecialGroupId: null,
    RmiRegionCode: string,
    RmiHdPregnantFlag: null,
    RmiLmpDate: null,
    RmiCategory: string,
    Capitated: false,
    RmiCountry: null
  }
};

export const getAuthMember = (searchReq: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_AUTH_MEMBER_REQUEST });

  return api.authorization.member.get(searchReq)
    .then((res: any) => {

      dispatch({
        type: types.GET_AUTH_MEMBER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_AUTH_MEMBER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const priorAuthValidation = (searchReq: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.VALIDATE_AUTH_REQUEST });

  return api.authorization.member.priorAuthValidation(searchReq)
    .then((res: any) => {

      dispatch({
        type: types.VALIDATE_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.VALIDATE_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateAddressAndPhoneNumber = (memberUpdateObj: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authMember.isUpdating) { return Promise.reject(); }

  dispatch({ type: types.UPDATE_ADDRESS_PHONE_NUM_REQUEST });

  return api.authorization.member.updateAddressAndPhone(memberUpdateObj)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_ADDRESS_PHONE_NUM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_ADDRESS_PHONE_NUM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
